module.exports = __webpack_public_path__ + "img/g矩形 82@1x.8c59f384.png";